module.exports = __webpack_public_path__ + "static/img/adv-banner-1.d2bfc2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/adv-banner-1.jpg
// module id = 9ted
// module chunks = 1